// index.tsx
import React, { useEffect, useRef, useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface"; // Ensure correct path

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
  loading,
  pagination,
  hidePagination = false,
  setSearchText = () => {},
  toolbarRightExtra,
  onSelectionChange,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [Selections, setSelections] = useState<any>(true);
  const [searchValue, setSearchValue] = useState<string>("");
  const timeoutRef = useRef<any>(null);
  const searchValueRef = useRef<string>("");

  const onSelectChange = (newSelectedRowKeys: any[], selectedRows: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (onSelectionChange) {
      onSelectionChange(newSelectedRowKeys, selectedRows);
    }
  };

  const handleSearch = (value: string) => {
    searchValueRef.current = value;
    setSearchValue(value);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setSearchText(value);
    }, 500);
  };


  const handleSearchSubmit = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setSearchText(searchValue);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  useEffect(() => {
    return setSelections(Selection);
  }, [Selection]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (searchValueRef.current) {
      setSearchValue(searchValueRef.current);
    }
  }, []);

  return (
    <>
      <div className="table-top-data d-flex px-3 justify-content-between align-items-center">
        <div className="page-range"></div>
        <div className="serch-global d-flex align-items-center gap-2 text-right">
          {toolbarRightExtra && (
            <div className="me-2 d-flex align-items-center">{toolbarRightExtra}</div>
          )}
          <div className="position-relative d-inline-block mb-3">
            <input
              type="text"
              className="form-control form-control-sm w-auto float-end pe-5"
              value={searchValue || searchValueRef.current}
              placeholder="Search"
              onChange={(e) => {
                const value = e.target.value;
                handleSearch(value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearchSubmit(e as any);
                }
              }}
              autoComplete="off"
              aria-controls="DataTables_Table_0"
            />
            {searchValue && (
              <button
                type="button"
                className="btn btn-link p-0 position-absolute"
                style={{
                  right: "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: "18px",
                  lineHeight: "1",
                  padding: "0 4px",
                  color: "#6c757d",
                }}
                onClick={() => {
                  searchValueRef.current = "";
                  setSearchValue("");
                  if (timeoutRef.current) clearTimeout(timeoutRef.current);
                  setSearchText("");
                }}
                aria-label="Clear search"
              >
                ×
              </button>
            )}
          </div>
        </div>
      </div>
      {!Selections ? (
        <Table
          className="table datanew dataTable no-footer"
          columns={columns}
          rowHoverable={false}
          dataSource={dataSource}
          loading={loading}
          rowKey="_id"
          pagination={
            hidePagination
              ? false
              : {
                  locale: { items_per_page: "" },
                  nextIcon: <span>Next</span>,
                  prevIcon: <span>Prev</span>,
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "15", "20"],
                  // No `pagination` prop from the caller means "here's the
                  // whole dataSource, paginate it yourself" (e.g. Courses
                  // List) -- omitting current/pageSize/total/onChange here
                  // leaves antd's own uncontrolled client-side paging in
                  // charge. Passing total:0 + onChange:undefined (the old
                  // unconditional behavior) silently broke that: antd
                  // treated the table as externally controlled with zero
                  // total items, so page clicks and page-size changes did
                  // nothing. Callers that DO pass `pagination` (server-side
                  // paged screens) are unaffected -- same object as before.
                  ...(pagination
                    ? {
                        current: pagination.currentPage || 1,
                        pageSize: pagination.limit || 10,
                        total: pagination.total || 0,
                        onChange: pagination.onChange,
                      }
                    : {}),
                }
          }
        />
      ) : (
        <Table
          className="table datanew dataTable no-footer"
          rowSelection={rowSelection}
          columns={columns}
          rowHoverable={false}
          loading={loading}
          dataSource={dataSource}
          rowKey="_id"
          pagination={
            hidePagination
              ? false
              : {
                  locale: { items_per_page: "" },
                  nextIcon: <span>Next</span>,
                  prevIcon: <span>Prev</span>,
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "30"],
                  // Same fix as above -- let antd self-paginate when no
                  // `pagination` prop is passed, instead of always forcing
                  // total:0/onChange:undefined.
                  ...(pagination
                    ? {
                        pageSize: pagination.limit,
                        total: pagination.total,
                        onChange: pagination.onChange,
                      }
                    : {}),
                }
          }
        />
      )}
    </>
  );
};

export default Datatable;